module.exports = __webpack_public_path__ + "static/media/37-5.0f14a892.mp3";